import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsStack } from "../types";

const SpaceDetailsStacksLabelsCell = ({
  item: stack,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsStack>) => (
  <TableSimpleCell {...cellProps}>
    <TableCellLabels tags={stack.labels} />
  </TableSimpleCell>
);

export default SpaceDetailsStacksLabelsCell;
